import Widget from "csi/form/Widget";
import declare from "dojo/_base/declare";
import { SUPPORTED_FILE_EXTENSION } from "./DGaaSForm";
import util from "csi/util";
import locale from "csi/locale";

const SOURCE_FILE_FIELD = "NewSourceFile";
const DGaaSUploadForm = declare(Widget, {
	/**
	 * @override
	 * Filter files with .docx extension for upload
	 */
	_resolveView: function() {
		this.inherited(arguments);
		var fileField = this.getField(SOURCE_FILE_FIELD);
		fileField["bForceEditable"] = true;
		fileField.widgetParams = {
			accept: SUPPORTED_FILE_EXTENSION,
		};
	},

	/**
	 * This method handles the file selection event. It checks if the selected file
	 * is a valid .docx file. If an invalid file is selected, an error message is displayed.
	 * Upon resubmission with a valid .docx file, the error message is removed.
	 */
	_onChangeFileField(defView, field, value) {
		const fileToRead = field.m_control.files[0];
		const ext = util.getFileExtension(fileToRead.name);
		if (!SUPPORTED_FILE_EXTENSION.includes(ext)) {
			field.errorMessage = locale.resource("UnsupportedDGaaSTemplateFile");
		} else {
			field.errorMessage = "";
		}
		this.errorForm(field.errorMessage, "");
	},
});
export = DGaaSUploadForm;

